
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Utils from "./Utils";

export default defineComponent({
  setup(props, context) {
    const store = useStore();
    const link = (path: number) => {
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "SetPosition", path);
      close();
    };

    const close = () => {
      context.emit("mapClose");
    };

    const map = ref<HTMLElement>();
    const resize = () => {
      if (!map.value) return;
      map.value.style.maxHeight = Utils.contentHeight("px");
    };

    onMounted(() => {
      resize();
    });

    const isInfoHover = ref<boolean>(false);
    const isTechHover = ref<boolean>(false);
    const isRealHover = ref<boolean>(false);
    const isDroneHover = ref<boolean>(false);
    const isShowroomHover = ref<boolean>(false);
    const isRoomHover = ref<boolean>(false);
    const isLifeHover = ref<boolean>(false);

    const pavillion = [
      {
        num: 1,
        sub: "一条の「性能」をいろいろ学べる",
        main: "テクノロジーミュージアム",
      },
      {
        num: 2,
        sub: "360度すみずみまで見られる",
        main: "バーチャル展示場",
      },
      {
        num: 3,
        sub: "オーナー様の住まいにドローンが潜入",
        main: "マイクロドローン ルームフライト",
      },
      {
        num: 4,
        sub: "暮らしがちょっと豊かになるお役立ち情報をお届け",
        main: "住まいと暮らしの豆知識",
      },
      {
        num: 5,
        sub: "オーナー様がご自宅のこだわりをご紹介",
        main: "ルームツアー",
      },
      {
        num: 6,
        sub: "等身大の一条の住まいを見学",
        main: "リアルサイズモデルハウス",
      },
    ];

    return {
      link,
      map,
      close,
      pavillion,
      isInfoHover,
      isTechHover,
      isRealHover,
      isDroneHover,
      isShowroomHover,
      isRoomHover,
      isLifeHover,
    };
  },
});
